export const camelize = (string: string): string =>
  string
    .replace(/(?:^\w|[A-Z]|\b\w)/g, (word, index) => (index === 0 ? word.toLowerCase() : word.toUpperCase()))
    .replace(/\s+/g, '')

export const replaceAll = (str: string, find: string, replace: string): string =>
  str.replace(new RegExp(find, 'g'), replace)
